import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Button } from './ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '../lib/utils';

export interface TransactionTypeOption {
  label: string;
  value: string;
}

interface TransactionTypeDropdownProps {
  options: TransactionTypeOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const TransactionTypeDropdown: React.FC<TransactionTypeDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Filter by type',
  className,
}) => {
  const [open, setOpen] = React.useState(false);

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (optionValue: string) => {
    if (value === optionValue) {
      onChange('');
    } else {
      onChange(optionValue);
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'h-10 w-[200px] justify-between border border-stone-300 bg-white text-left font-normal shadow-sm hover:bg-stone-50',
            className,
          )}
        >
          <span className="text-sm font-normal text-stone-900 truncate">
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          {open ? (
            <ChevronUp className="h-4 w-4 text-stone-500" />
          ) : (
            <ChevronDown className="h-4 w-4 text-stone-500" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0 bg-white" align="start">
        <div className="py-1">
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={cn(
                'flex cursor-pointer items-center px-4 py-2.5 text-sm hover:bg-stone-50',
                value === option.value && 'bg-stone-50',
              )}
            >
              <div className="mr-3">
                {value === option.value ? (
                  <span className="flex h-5 w-5 items-center justify-center rounded-full border-2 border-gray-700 bg-white">
                    <span className="block h-2.5 w-2.5 rounded-full bg-gray-700"></span>
                  </span>
                ) : (
                  <span className="flex h-5 w-5 items-center justify-center rounded-full border-2 border-gray-400 bg-white"></span>
                )}
              </div>
              <span className="font-medium text-gray-700">{option.label}</span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default TransactionTypeDropdown;
